export default __webpack_public_path__ + "static/media/eniopro1_white.7373e19c.svg";